var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"designer"}}),_c('modalTemplatesVue',{on:{"selectedTemplate":_vm.setTemplate}}),_c('dataSourceModal',{attrs:{"tables":_vm.tables},on:{"changeDataSource":_vm.changeDataSource,"selectedTables":_vm.selectedTables}}),_c('tipoReporte',{on:{"datasetDocuemntos":_vm.changeDataSource,"selectedTables":_vm.selectedTables,"tablesMaestros":(v) => {
                _vm.tables = v
                _vm.requestSourceData()
            }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }